export const handleSort = (a, b) => {
  let fa = a?.group_name ? a?.group_name?.toLowerCase()?.replace(/ +/g, "") : "";
  let fb = b?.group_name ? b?.group_name?.toLowerCase()?.replace(/ +/g, "") : "";
  if (fa < fb) return -1;
  else if (fa > fb) return 1;
  else return 0;
};
